enum WorkReportType {
    TEAM_ALIGNMENT = 'team_alignment',
    CLIENT_ALIGNMENT = 'client_alignment',
    QA = 'qa',
    DESIGN = 'design',
    REVISION = 'revision',
}

export default WorkReportType;
